import { createSlice } from '@reduxjs/toolkit';
import { getTotalStatistic } from './statisticThunk';

export interface StatisticState {}

const initialState: StatisticState = {};

const statisticSlice = createSlice({
  name: 'statisticState',
  initialState,
  reducers: {},
  extraReducers(builder) {
    // GET: total statistic summary
    builder
      .addCase(getTotalStatistic.pending, (_state) => {})
      .addCase(getTotalStatistic.fulfilled, (_state) => {})
      .addCase(getTotalStatistic.rejected, (_state) => {});
  },
});

// Action
export const statisticActions = statisticSlice.actions;

// Reducer
const statisticReducer = statisticSlice.reducer;
export default statisticReducer;
